<template>
  <pagefra>
    <div class="diagnosis container">
      <panel type="toolbar">
        <div class="toolbar">
          <el-form
            class="toolbar-form"
            :inline="true"
            v-model="form"
            label-width
          >
            <el-form-item :label="$l('工号')">
              <el-input
                v-model="form.deviceNo"
                :placeholder="$l('工号')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('YCD码')">
              <el-input
                v-model="form.ycdcode"
                :placeholder="$l('YCD码')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('诊断时间')">
              <el-date-picker
                v-model="diagnosisTimeValues"
                type="datetimerange"
                :range-separator="$l('至')"
                :start-placeholder="$l('诊断开始时间')"
                :end-placeholder="$l('诊断结束时间')"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button
                icon="el-icon-search"
                type="primary"
                circle
                @click="search"
              ></el-button>
            </el-form-item>
          </el-form>
        </div>
      </panel>
      <panel class="panel-table">
        <div class="panel-table__table">
          <el-table
            ref="filterTable"
            size="medium"
            tooltip-effect="tableTooltip"
            highlight-current-row
            height="100%"
            v-loading.lock="loading"
            :data="tableData"
            style="width: 100%; z-index: 1000"
          >
            <el-table-column
              type="index"
              :label="$l('S.N.')"
              width="80"
              align="center"
            ></el-table-column>
            <!-- <el-table-column
              :label="$l('YCD record ID')"
              prop="id"
              align="center"
              min-width="120"
            ></el-table-column> -->
            <el-table-column
              :label="$l('EQ No.')"
              prop="deviceNo"
              align="center"
              width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('Operation Task')"
              prop="ycdcode"
              align="center"
              width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('YCD creation date in RMS')"
              prop="diagnoseTime"
              align="center"
              width="200"
            ></el-table-column>
            <el-table-column
              :label="$l('YCD Value')"
              prop="diagValue"
              align="center"
              width="120"
              :formatter="diagValueFormatter"
            ></el-table-column>
            <el-table-column
              :label="$l('YCD Detail')"
              prop="diagnoseDesc"
              align="center"
              width="200"
            ></el-table-column>
            <el-table-column
              :label="$l('RCM Created SO No.')"
              prop="sono"
              align="center"
              width="200"
            ></el-table-column>
            <el-table-column
              :label="$l('RCM Created SO status')"
              prop="sostatus"
              align="center"
              width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('SO Actual Date')"
              prop="soactualDate"
              align="center"
              width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('Diagnostic result')"
              prop="soremark"
              align="center"
              width="126"
            ></el-table-column>
            <el-table-column
              :label="$l('FE')"
              prop="fe"
              align="center"
              width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('RCMStatus')"
              prop="rcmstatus"
              align="center"
              width="120"
            ></el-table-column>
            <!-- <el-table-column
              :label="$l('RCMCreationFlag')"
              prop="rcmcreationFlag"
              align="center"
              width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('ErrorMessage')"
              prop="errorMessage"
              align="center"
              width="120"
            ></el-table-column> -->
            <!-- <el-table-column
              :label="$l('RCMRemark')"
              prop="rcmremark"
              align="center"
              width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('Unit')"
              prop="unit"
              align="center"
              width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('DiagnosisName')"
              prop="diagnosisName"
              align="center"
              width="120"
            ></el-table-column> -->
          </el-table>
        </div>
        <el-pagination
          :current-page="pageConfig.currentPage"
          :page-sizes="pageConfig.pageSizes"
          :page-size="pageConfig.pageSize"
          :total="pageConfig.total"
          @size-change="handlePageSizeChange"
          @current-change="handleCurrentPageChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </panel>
    </div>
  </pagefra>
</template>

<script>
// @ is an alias to /src
import panel from "@/components/panel.vue";
import global from "@/mixins/global.js";
export default {
  name: "diagnosis",
  mixins: [global],
  components: {
    panel,
  },
  props: {
    loaded: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      form: {
        deviceNo: "",
        ycdcode: "",
        startDiagnosisTime: "",
        endDiagnosisTime: "",
      },
      tableData: [],
      loading: false,
      diagnosisTimeValues: [],
    };
  },
  mounted() {
    if (this.loaded) {
      this.initData();
    }
  },
  methods: {
    handlePageSizeChange(val) {
      this.pageConfig.pageSize = val;
      this.initData();
    },
    handleCurrentPageChange(val) {
      this.pageConfig.currentPage = val;
      this.initData();
    },
    search() {
      this.pageConfig.currentPage = 1;
      this.initData();
    },
    initData() {
      const dataListCacheKey = this.$options.name + "_data_list";
      const dataTotalCacheKey = this.$options.name + "_data_total";
      if (this.$store.state.pageScroll.scroll) {
        const json = sessionStorage.getItem(dataListCacheKey);
        if (json) {
          this.tableData = JSON.parse(json);
          this.pageConfig.total = parseInt(
            sessionStorage.getItem(dataTotalCacheKey)
          );
          sessionStorage.removeItem(dataTotalCacheKey);
          sessionStorage.removeItem(dataListCacheKey);
          return;
        }
      }
      this.form.pageNum = this.pageConfig.currentPage;
      this.form.pageSize = this.pageConfig.pageSize;
      if (this.diagnosisTimeValues && this.diagnosisTimeValues.length == 2) {
        this.form.startDiagnosisTime = this.$common.formatDateTime(
          this.diagnosisTimeValues[0]
        );
        this.form.endDiagnosisTime = this.$common.formatDateTime(
          this.diagnosisTimeValues[1]
        );
      } else {
        this.form.startDiagnosisTime = null;
        this.form.endDiagnosisTime = null;
      }
      this.tableData = [];
      this.loading = true;
      this.$http
        .post(this.$apiConfig.search_diagnosis_url, this.form)
        .then((response) => {
          this.loading = false;
          let result = response.data;
          if (result.code == 0) {
            this.pageConfig.total = result.data.total;
            this.tableData = result.data.result;
            if (
              !this.loaded &&
              this.$store.state.pageScroll.scroll &&
              !sessionStorage.getItem(dataListCacheKey)
            ) {
              sessionStorage.setItem(dataTotalCacheKey, this.pageConfig.total);
              sessionStorage.setItem(
                dataListCacheKey,
                JSON.stringify(this.tableData)
              );
            }
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    diagValueFormatter(row) {
      if (row.diagValue) {
        return row.diagValue + (row.unit ? " " + row.unit : "");
      }
      return "";
    },
  },
};
</script>
<style lang="scss" scoped>
.diagnosis {
}
</style>
